import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import deckingImage from "@/assets/products/wpc-decking-teak.jpg";

export function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={deckingImage}
          alt="Premium decking project"
          className="h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/85 to-primary/70" />
      </div>

      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mx-auto max-w-3xl text-center"
        >
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="mb-6 text-3xl font-bold tracking-tight text-primary-foreground md:text-4xl lg:text-5xl"
          >
            Ready to Start Your Project?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="mb-10 text-lg text-primary-foreground/90 max-w-2xl mx-auto"
          >
            Whether you're a homeowner planning a renovation or a contractor managing multiple sites, we have the materials and expert support you need.
          </motion.p>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="flex flex-col justify-center gap-4 sm:flex-row"
          >
            <Button asChild variant="hero" size="xl" className="shadow-lg">
              <Link to="/shop">
                Browse Products
              </Link>
            </Button>
            <Button 
              asChild 
              variant="heroOutline" 
              size="xl"
            >
              <Link to="/quote">
                Get a Quote
              </Link>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
